// Man dat ket qua tung game (cms/apps/api routes/admin/ep_ket_qua.ts, backend lib/van_cms.js).

export type Man = 'tai_xiu' | 'bau_cua' | 'xoc_dia' | 'sicbo' | 'rong_ho' | 'baccarat' | 'xeng' | 'keno' | 'aviator' | 'lode' | 'nguoi';
export type Nhom = 'mini' | 'ban' | 'so' | 'nguoi';
export type KQ = Record<string, unknown>;

export type Game = {
  id: string; ten: string; loai: 'van' | 'nguoi'; hu: boolean; dang: string[]; cuaMax?: number; ghiChu?: string;
  man: Man; nhom: Nhom; cho?: number;
};

export type Lenh = {
  id: number; game_id: string; pham_vi: string; user_id: number | null; nick: string | null; ket_qua: KQ; ket_qua_ra: unknown;
  so_lan: number; da_dung: number; trang_thai: string; ly_do: string | null; tao_boi: string | null; luc: string;
  luc_dung: string | null; loi: string | null; phien: string | null;
};

export type Cuoc = {
  user_id: number | string; nick: string; cua: number | string; tien: number; loai: 'vin' | 'xu'; luc?: number | string;
  tu_rut?: number | null; da_rut?: number; thang?: number; so?: number[] | string; ty_le?: number | null; tien_mot_so?: number;
};

export type DuDoan = { ket_qua: KQ; mo_ta?: string; cua_thang?: number[]; xac_suat?: number; cuoc: number; tra: number; lai: number; hoan?: number };

export type LichSu = {
  phien: string; phien_hien?: string; xuc_xac?: number[]; tong?: number; cua?: string | number; mo_ta?: string; cua_thang?: number[];
  d1?: number; diem_no?: number; so?: number[]; special?: string; de?: string; loai_thang?: string;
};

export type Van = {
  ok: true; gid: string; phien: string; phien_hien?: string; phien_lenh?: string; ten_kenh?: string;
  giai_doan: string; nhan_lenh: boolean; con_lai_ms: number; het_han_ms?: number;
  cua: { ma: number; ten?: string }[]; cuoc: Cuoc[]; lich_su: LichSu[];
  ket_qua: (KQ & { khoa?: boolean; bam?: string }) | null; du_doan: DuDoan[];
  quy?: { bat: boolean; so_du: number | null }; he_so?: number; diem_no?: number;
};

export type NguoiChoi = { user_id: number; nick: string | null; so_luot: number; so_luot_xu?: number; cuoc: number; tra: number; cuoi: number; online: boolean | null };
export type Luot = { id: number; user_id: number; nick: string | null; luc: number; cuoc: number; tra: number; xu?: boolean };

export type ManData = { game: Game; lenh: Lenh[]; van: Van | null; van_loi: string | null; nguoi_choi?: NguoiChoi[]; luot?: Luot[] };

// ------------------------------------------------------------------ nhan

export const TRANG_THAI: Record<string, string> = { CHO: 'Đang chờ', DA_DUNG: 'Đã dùng', LOI: 'Lỗi', HUY: 'Đã hủy', HET_HAN: 'Hết hạn' };
export const TRANG_THAI_TAG: Record<string, 'blue' | 'green' | 'red' | 'gray' | 'warm-gray'> = {
  CHO: 'blue', DA_DUNG: 'green', LOI: 'red', HUY: 'gray', HET_HAN: 'warm-gray',
};
export const GIAI_DOAN: Record<string, string> = {
  cuoc: 'Đang nhận cược', dong_cuoc: 'Đã đóng cược', mo_ket_qua: 'Đang mở kết quả', tra_thuong: 'Đang trả thưởng',
  chuan_bi: 'Chuẩn bị ván mới', bay: 'Máy bay đang bay', no: 'Máy bay đã nổ', khac: 'Đang chạy',
};
export const NHOM: Record<Nhom, string> = {
  mini: 'Mini game', ban: 'Bàn trực tiếp', so: 'Xổ số nhanh', nguoi: 'Slot và mini game theo người chơi',
};

export const MAT_BAU_CUA = ['Bầu', 'Cua', 'Tôm', 'Cá', 'Gà', 'Nai'];
export const XUC_XAC = ['⚀', '⚁', '⚂', '⚃', '⚄', '⚅'];
const CAP: Record<number, [number, number]> = {
  18: [1, 2], 19: [1, 3], 20: [1, 4], 21: [1, 5], 22: [1, 6], 23: [2, 3], 24: [2, 4], 25: [2, 5], 26: [2, 6],
  27: [3, 4], 28: [3, 5], 29: [3, 6], 30: [4, 5], 31: [4, 6], 32: [5, 6],
};
export const RONG_HO: Record<number, string> = { 1: 'Rồng', 2: 'Hổ', 3: 'Hòa' };
export const BACCARAT: Record<number, string> = {
  1: 'Con', 2: 'Cái', 3: 'Hòa', 4: 'Đôi Con', 5: 'Đôi Cái', 6: 'Lucky 88', 7: 'Con 8 điểm', 8: 'Cái 8 điểm',
};
const KENO: Record<string, string> = {
  TAI: 'Tài', XIU: 'Xỉu', CHAN: 'Chẵn', LE: 'Lẻ', KIM: 'Kim', MOC: 'Mộc', THUY: 'Thủy', HOA: 'Hỏa', THO: 'Thổ',
  BIG: 'Tài', SMALL: 'Xỉu', ODD: 'Lẻ', EVEN: 'Chẵn', GOLD: 'Kim', WOOD: 'Mộc', WATER: 'Thủy', FIRE: 'Hỏa', EARTH: 'Thổ',
};

function sicboCua(c: number): string {
  if (c === 1) return 'Chẵn';
  if (c === 2) return 'Lẻ';
  if (c === 3) return 'Tài';
  if (c === 4) return 'Xỉu';
  if (c >= 5 && c <= 10) return 'Đôi ' + (c - 4);
  if (c === 11) return 'Bộ ba bất kỳ';
  if (c >= 12 && c <= 17) return 'Bộ ba ' + (c - 11);
  const cap = CAP[c];
  if (cap) return 'Cặp ' + cap[0] + '-' + cap[1];
  if (c >= 33 && c <= 38) return 'Số ' + (c - 32);
  if (c >= 39 && c <= 52) return 'Tổng ' + (c - 35);
  return 'Cửa ' + c;
}

export function tenCua(man: Man, ma: number | string, van?: Van | null): string {
  const n = Number(ma);
  switch (man) {
    case 'tai_xiu': return n === 1 ? 'Tài' : 'Xỉu';
    case 'bau_cua': case 'xoc_dia': return van?.cua.find((c) => c.ma === n)?.ten ?? 'Cửa ' + ma;
    case 'sicbo': return sicboCua(n);
    case 'rong_ho': return RONG_HO[n] ?? 'Cửa ' + ma;
    case 'baccarat': return BACCARAT[n] ?? 'Cửa ' + ma;
    case 'keno': {
      const s = String(ma).toUpperCase();
      const x = /^(TRUOT_)?XIEN_(\d+)$/.exec(s);
      if (x) return (x[1] ? 'Trượt xiên ' : 'Xiên ') + x[2];
      return KENO[s] ?? String(ma);
    }
    case 'aviator': return 'Cược';
    default: return typeof ma === 'string' ? ma : 'Cửa ' + ma;
  }
}

const tong3 = (d: number[]) => d.reduce((a, b) => a + b, 0);
const laXuc = (x: unknown, min: number, max: number): x is number[] =>
  Array.isArray(x) && x.length === 3 && x.every((v) => Number.isInteger(v) && v >= min && v <= max);

// Mo ta mot ket qua (lenh ep, lich su, du doan) bang chu cho nguoi doc
export function moTaKQ(man: Man, k: KQ | null | undefined): string {
  if (!k) return '-';
  if (k.thua === true) return 'Thua';
  if (k.no_hu === true) return 'Nổ hũ';
  if (k.thang === true) return typeof k.he_so === 'number' ? `Thắng, tối thiểu x${k.he_so} tiền cược` : 'Thắng';
  if (k.cua === 'tai') return 'Tài';
  if (k.cua === 'xiu') return 'Xỉu';
  if (man === 'bau_cua' && laXuc(k.xuc_xac, 0, 5)) return k.xuc_xac.map((x) => MAT_BAU_CUA[x]).join(' · ');
  if (laXuc(k.xuc_xac, 1, 6)) {
    const t = tong3(k.xuc_xac);
    const boBa = k.xuc_xac[0] === k.xuc_xac[1] && k.xuc_xac[1] === k.xuc_xac[2];
    return `${k.xuc_xac.join('-')} (${t}, ${man === 'sicbo' && boBa ? 'bộ ba' : t >= 11 ? 'Tài' : 'Xỉu'})`;
  }
  if (typeof k.so_do === 'number') return `${k.so_do} đỏ ${4 - k.so_do} trắng`;
  if (Array.isArray(k.dong_xu)) return (k.dong_xu as number[]).map((x) => (x === 0 ? 'đỏ' : 'trắng')).join(' ');
  if (Array.isArray(k.cua_thang)) return (k.cua_thang as number[]).map((c) => tenCua(man, c)).join(' + ');
  if (typeof k.bt === 'number') return 'Biểu tượng ' + k.bt;
  if (Array.isArray(k.so)) return '20 số: ' + (k.so as number[]).slice().sort((a, b) => a - b).join(' ');
  if (typeof k.diem_no === 'number') return k.diem_no + 'x';
  if (typeof k.special === 'string') return 'Đặc biệt ' + k.special;
  if (typeof k.de === 'string') return 'Đề ' + k.de;
  return JSON.stringify(k);
}

// Nhan ngan tren bang cau: T/X cho Tai Xiu, ten mat, ...
export function maNgan(man: Man, k: KQ | null | undefined): string {
  if (!k) return '?';
  if (k.cua === 'tai') return 'T';
  if (k.cua === 'xiu') return 'X';
  if (man === 'tai_xiu' && laXuc(k.xuc_xac, 1, 6)) return tong3(k.xuc_xac) >= 11 ? 'T' : 'X';
  if (man === 'bau_cua' && laXuc(k.xuc_xac, 0, 5)) return k.xuc_xac.map((x) => (MAT_BAU_CUA[x] ?? '?').slice(0, 2)).join('');
  if (laXuc(k.xuc_xac, 1, 6)) return String(tong3(k.xuc_xac));
  if (typeof k.so_do === 'number') return k.so_do + 'Đ';
  if (Array.isArray(k.cua_thang)) return (k.cua_thang as number[]).map((c) => tenCua(man, c)).join('+');
  if (typeof k.diem_no === 'number') return k.diem_no + 'x';
  if (typeof k.de === 'string') return k.de;
  if (typeof k.special === 'string') return k.special.slice(-2);
  if (typeof k.bt === 'number') return 'BT' + k.bt;
  if (Array.isArray(k.so)) return 'Keno';
  return '?';
}

export const bangNhau = (a: KQ | null | undefined, b: KQ | null | undefined) => !!a && !!b && JSON.stringify(a) === JSON.stringify(b);
export const vnd = (n: number) => Math.trunc(n).toLocaleString('vi-VN');
